import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Sections from '~/constants/sections';
import {
  getHasOwnerReviews,
  getIsLite,
  getShouldShowPriceDetails
} from '~/selectors';

export type OwnProps = { label: string; value: string; sortKey: number }[];

const useMobileStickyDropDownOptions = (): OwnProps => {
  const hasOwnerReviews = useSelector(getHasOwnerReviews);
  const shouldShowPriceDetails = useSelector(getShouldShowPriceDetails);
  const isLite = useSelector(getIsLite);

  return useMemo(() => {
    const options = [
      {
        label: 'Key Features',
        value: `#${Sections.KeyFeatures}`,
        sortKey: isLite ? 2 : 1
      },
      {
        label: 'Vehicle Details',
        value: `#${Sections.VehicleDetails}`,
        sortKey: isLite ? 3 : 2
      },
      shouldShowPriceDetails && {
        label: 'Price Details',
        value: `#${Sections.PriceDetails}`,
        sortKey: isLite ? 1 : 3
      },
      hasOwnerReviews && {
        label: 'Owner Reviews',
        value: `#${Sections.OwnerReviews}`,
        sortKey: isLite ? 6 : 4
      },
      {
        label: 'Inspection & History',
        value: `#${Sections.Inspection150Point}`,
        sortKey: isLite ? 4 : 5
      },
      {
        label: 'Money Back Guarantee',
        value: `#${Sections.BuyWithConfidence}`,
        sortKey: isLite ? 5 : 6
      }
    ].filter(Boolean) as OwnProps;

    return options.sort((a, b) => a.sortKey - b.sortKey);
  }, [hasOwnerReviews, isLite, shouldShowPriceDetails]);
};

export default useMobileStickyDropDownOptions;
